import React, { useEffect, useRef, useCallback } from "react";

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { statusAdded, statusGetById } from "../../../Redux/statusReduce";
import { useTranslation } from 'react-multi-lang'
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { verification } from "../../../Redux/usersReduce";

function AjouterStatus({client}) {
  const t = useTranslation();
  const notify = (status, msg) => {
    if (status === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const [nom, setNom] = React.useState("");
  const [nomEn, setNomEn] = React.useState("");
  const [mail, setMail] = React.useState("");
  const [defaultR, setDefaultR] = React.useState(0);
  const [order, setOrder] = React.useState("");
  const [id, setId] = React.useState(0);
  const saveCalled = useRef(false);
  function submitForm(event) {
    if (nom !== "" && nomEn !== "") {
      if (saveCalled.current) return;
      saveCalled.current = true;
      dispatch(statusAdded({ nom, nomEn, id, defaultR,mail }));
      if (isNaN(location.id) === true) {
        notify(1, t("add_txt"));
        setTimeout(async () => {
          listeStatus();
        }, 800);
      } else {
        notify(1, t("update_txt"));
        setTimeout(async () => {
          listeStatus();
        }, 800);
      }
    } else {
      notify(2, t("Status.status_obligatoire"));
    }
  }

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    async function getStatus() {
      if (isNaN(location.id) === false) {
        var status = await dispatch(statusGetById(location.id));
        var entities = status.payload;
        setNom(entities.nom);
        setNomEn(entities.nom_en);
        setMail(entities.mail);
        setDefaultR(entities.defaultr);
        setId(location.id);
      }
    }
    getStatus();
  }, [location.id, dispatch]);

  function listeStatus() {
    navigate.push(client+"/statusList");
  }
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeStatus}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ?
                        t("status.add")
                        : t("status.update")}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>   {t("name")} * </label>
                          <Form.Control
                            defaultValue={nom}
                            placeholder="Nom"
                            type="text"
                            onChange={(value) => {
                              setNom(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>

                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>   {t("name")} En* </label>
                          <Form.Control
                            defaultValue={nomEn}
                            placeholder="Nom En"
                            type="text"
                            onChange={(value) => {
                              setNomEn(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <Form.Group>
                          <Form.Check>
                            <Form.Check.Label>
                              <Form.Check.Input
                                type="checkbox"
                                checked={defaultR == 1 ? true : false}
                                onChange={(v) => {
                                  if (v.target.checked) {
                                    setDefaultR(1);
                                  }
                                  else setDefaultR(0)
                                }}
                              ></Form.Check.Input>
                              <span className="form-check-sign"></span>
                              <label>Par défaut</label>
                            </Form.Check.Label>
                          </Form.Check>
                        </Form.Group>
                      </Col>

                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>   {t("email")}  </label>
                          <Form.Control
                            as={"textarea"}
                            defaultValue={mail}
                            placeholder="E-mail"
                            type="text"
                            onChange={(value) => {
                              setMail(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t("save")}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default AjouterStatus;
